import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { UseCases } from "@planzone/core";
import { useAddResourceToResourceGroup } from "@planzone/view-models";

import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { DropBox, useDragAndDrop } from "@common/dragAndDrop";
import { SecureContextualMenu } from "@common/secureContextualMenu";
import { GroupIcon } from "./groupIcon";
import styles from "./styles.scss";

function Group({ group, project, isSelected, select, unSelect }: Props) {
  const { pushView } = useModal();
  const { t } = useTranslation();
  const { data } = useDragAndDrop();
  const { isRequestPending, addResourceToResourceGroup } =
    useAddResourceToResourceGroup(group, data.payload);

  return (
    <DropBox
      acceptedTypes={["MOVE_RESOURCE"]}
      drop={({ payload }) =>
        !isRequestPending &&
        addResourceToResourceGroup({ group, resource: payload })
      }
      isDisabled={({ payload }) =>
        !!group.resources.find(({ uuid }) => uuid === payload.uuid)
      }
    >
      {(_, canDrop) => (
        <div
          className={classNames(styles.group, { [styles.droppable]: canDrop })}
        >
          <div
            className={classNames(styles.main, {
              [styles.selected]: isSelected,
            })}
            onClick={() => (isSelected ? unSelect(group) : select(group))}
          >
            <GroupIcon className={styles.groupIcon} />
            <p className={styles.name}>{group.name}</p>
          </div>
          <div className={styles.menu}>
            <SecureContextualMenu
              items={[
                {
                  name: t("membersList.contextualMenu.edit"),
                  useCase: UseCases.editResourceGroup,
                  act: () =>
                    pushView({
                      key: UseCases.editResourceGroup,
                      data: { group, namespace: project.uuid },
                    }),
                },
                {
                  name: t("membersList.contextualMenu.delete"),
                  color: "#DB5F63FF",
                  useCase: UseCases.removeResourceGroup,
                  act: () =>
                    pushView({
                      key: UseCases.removeResourceGroup,
                      data: group,
                    }),
                },
              ]}
            />
          </div>
        </div>
      )}
    </DropBox>
  );
}

export { Group };
